import { SystemLogEventActionEnum } from './system-log-event-action-enum'
import { Operator } from './operator'
import { SystemReflection } from './system-reflection'
import { InformalReflection } from './informal-reflection'
import { Reflection } from './reflection'

export interface SystemLogInterface {
  eventAction?: SystemLogEventActionEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 Id
   */
  schoolId: number
  operatorId?: number
  /**
   * 操作者所属领域
   */
  operatorDomain: string
  /**
   * 操作者对象
   */
  operator?: Operator | null
  /**
   * 系统用户
   */
  systemOperator?: SystemReflection | null
  /**
   * 非正式用户
   */
  informalOperator?: InformalReflection | null
  /**
   * 正式用户
   */
  formalOperator?: Reflection | null
  /**
   * 文本描述
   */
  summary: string
  /**
   * 自定义属性
   */
  attributes?: object | null
  /**
   * 操作时间
   */
  operatedAt: string
  /**
   * 操作者IP
   */
  ip?: string
  /**
   * 操作者OS
   */
  os?: string
  /**
   * 操作者浏览器
   */
  browser?: string
  /**
   * 操作者地址
   */
  address?: string
}

export class SystemLog implements SystemLogInterface {
  eventAction?: SystemLogEventActionEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 Id
   */
  schoolId: number
  operatorId?: number
  /**
   * 操作者所属领域
   */
  operatorDomain: string
  /**
   * 操作者对象
   */
  operator?: Operator | null
  /**
   * 系统用户
   */
  systemOperator?: SystemReflection | null
  /**
   * 非正式用户
   */
  informalOperator?: InformalReflection | null
  /**
   * 正式用户
   */
  formalOperator?: Reflection | null
  /**
   * 文本描述
   */
  summary: string
  /**
   * 自定义属性
   */
  attributes?: object | null
  /**
   * 操作时间
   */
  operatedAt: string
  /**
   * 操作者IP
   */
  ip?: string
  /**
   * 操作者OS
   */
  os?: string
  /**
   * 操作者浏览器
   */
  browser?: string
  /**
   * 操作者地址
   */
  address?: string

  constructor(props: SystemLogInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      eventAction: _eventAction,
      id: _id,
      schoolId: _schoolId,
      operatorId: _operatorId,
      operatorDomain: _operatorDomain,
      operator: _operator,
      systemOperator: _systemOperator,
      informalOperator: _informalOperator,
      formalOperator: _formalOperator,
      summary: _summary,
      attributes: _attributes,
      operatedAt: _operatedAt,
      ip: _ip,
      os: _os,
      browser: _browser,
      address: _address,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.eventAction = _eventAction
    this.id = _id
    this.schoolId = _schoolId
    this.operatorId = _operatorId
    this.operatorDomain = _operatorDomain
    this.operator = _operator ? new Operator(_operator) : _operator
    this.systemOperator = _systemOperator
      ? new SystemReflection(_systemOperator)
      : _systemOperator
    this.informalOperator = _informalOperator
      ? new InformalReflection(_informalOperator)
      : _informalOperator
    this.formalOperator = _formalOperator
      ? new Reflection(_formalOperator)
      : _formalOperator
    this.summary = _summary
    this.attributes = _attributes
    this.operatedAt = _operatedAt
    this.ip = _ip
    this.os = _os
    this.browser = _browser
    this.address = _address
  }
}
